import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import View from '../view';
import Text from '../text';
import Icon, { IIconProps } from '../icon';

export interface ICellProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 左侧标题
   */
  title?: string;
  /**
   * 左侧图标，参考 Icon 组件
   */
  icon?: IIconProps;
  /**
   * 标题下方描述信息
   */
  label?: string;
  /**
   * 右侧内容
   */
  value?: string;
  /**
   * 是否垂直居中
   * @default false
   */
  center?: boolean;
  /**
   * 是否开启点击反馈
   * @default false
   */
  clickable?: boolean;
  /**
   * 是否为 link （展示右侧图标）
   */
  isLink?: boolean;
  /**
   * 右侧图标名称或链接
   * @default chevron-right
   */
  linkIcon?: string;
  /**
   * 自定义渲染左侧 title 内容
   */
  renderTitle?: () => ReactNode;
  /**
   * 自定义渲染左侧标题下方 label 内容
   */
  renderLabel?: () => ReactNode;
  /**
   * 自定义渲染右侧 value 内容
   */
  renderValue?: () => ReactNode;
}

const Cell: FC<ICellProps> = ({ className, title, label, icon, value, center = false, isLink = false, clickable = false, linkIcon = 'chevron-right', renderTitle, renderLabel, renderValue }) => {
  const rootClass = classNames('ink-cell', { 'ink-cell--center': center, 'ink-cell--clickable': clickable }, className);
  return (
    <View className={rootClass}>
      <View className="ink-cell__title">
        {renderTitle ? (
          renderTitle()
        ) : (
          <View className="ink-cell__text">
            {icon && <Icon className="ink-cell__icon" {...{ size: 32, ...icon }} />}
            {title && <Text>{title}</Text>}
          </View>
        )}
        {renderLabel ? renderLabel() : label && <View className="ink-cell__label">{label}</View>}
      </View>
      {renderValue ? renderValue() : value && <View className="ink-cell__value">{value}</View>}
      {isLink && <Icon className="ink-cell__link" name={linkIcon} />}
    </View>
  );
};

export default Cell;
